module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table w100\">\n    <div name=\"filter-row\">\n        ")
    ;  for (var i = 0; i < controls.length; i++) { 
    ; __append("\n            ")
    ;  var control = controls[i] 
    ; __append("\n            ")
    ; __append( UI.Template.render(widget.templateCell, { widget: widget, control: control }) )
    ; __append("\n        ")
    ;  } 
    ; __append("\n    </div>\n</div>\n")
  }
  return __output.join("");

}